import { useQuery, UseQueryResult } from 'react-query'
import { AxiosResponse } from 'axios'

import { useFetch } from 'providers/FetchProvider'
import { ChatSettings } from './types'
import { GET_CHAT_SETTINGS_QUERY_KEY } from './keys'

const useGetChatSettingsQuery = ()
: UseQueryResult<AxiosResponse<ChatSettings>, unknown> => {
  const { fetch } = useFetch()

  return useQuery(
    GET_CHAT_SETTINGS_QUERY_KEY,
    () => fetch.get('/chat-settings')
  )
}

export { useGetChatSettingsQuery }
